import { render, staticRenderFns } from "./cadbancos.vue?vue&type=template&id=46a02cb0&"
import script from "./cadbancos.vue?vue&type=script&lang=js&"
export * from "./cadbancos.vue?vue&type=script&lang=js&"
import style0 from "./cadbancos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports